import { render, staticRenderFns } from "./WIPFC.vue?vue&type=template&id=458b00a4&scoped=true&"
import script from "./WIPFC.vue?vue&type=script&lang=js&"
export * from "./WIPFC.vue?vue&type=script&lang=js&"
import style0 from "./WIPFC.vue?vue&type=style&index=0&id=458b00a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b00a4",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QTooltip,QSelect,QBtn,QMarkupTable,QPagination} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QTooltip,QSelect,QBtn,QMarkupTable,QPagination}, component.options.components || {})
